<div class="flex align-items-center hover-element">
  <i class="pi pi-map pl-2 cursor-pointer" (click)="popoverNotifyNearby.toggle($event)"></i>
  <p-button icon="pi pi-bell"
            class="button-no-background"
            [styleClass]="'p-button-text ' + (eventNotificationActive ? 'text-green' : 'text-white')"
            (onClick)="popoverNotifyNearby.toggle($event)"/>
</div>

<ng-template #notifyTemplate let-item="data" pTemplate="item">
  <div class="flex align-items-center gap-2"
       [class.align-items-center]="!mobileView"
       [class.flex-row]="!mobileView"
       [class.flex-column]="mobileView">
    <div>
      <app-switch [(value)]="eventNotificationActive" label="NOTIFY_NEARBY" class="pt-1"
                  (valueChange)="saveSettings()" [disabled]="isSaving"/>
    </div>

    <div class="flex align-items-center gap-2">
      @if (playerProfile.postalCode) {
        @if (mobileView) {
          <span>{{ 'RADIUS' | translate }}:</span>
        } @else {
          <i class="pi pi-map pl-2"></i>
        }
        <app-input-number [(value)]="eventNotificationRadius" styleClass="w-3rem"
                          (onValueChanged)="saveSettings()" [disabled]="isSaving"/>
        <span>km</span>
      } @else {
        <p-button icon="pi pi-id-card" styleClass="p-button-text"
                  routerLink="/frontend/player/profile/account/personalData"
                  [label]="'PERSONAL_DATA' | translate"/>
      }
    </div>
    <div class="flex align-items-center gap-2">
      <span>{{ 'DART_TYPE' | translate }}:</span>
      <app-dropdown-domain domainCd="DOMAIN_DART_TYPE" [domainValues]="dartTypeValues"
                           [showDefault]="true" [(value)]="dartTypePreferenceCd"
                           (onValueChanged)="saveSettings()"/>
    </div>
  </div>
</ng-template>

<p-popover #popoverNotifyNearby #content>
  <ng-container [ngTemplateOutlet]="notifyTemplate" [ngTemplateOutletContext]="{data: playerProfile}"/>
</p-popover>
